import styled from 'styled-components';

export const AppPlaceholderLoader = styled.div`
  width: 100%;
  height: 100vh;
`;
